import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import "@grapecity/spread-sheets/styles/gc.spread.sheets.excel2013white.css";
import GC from "@grapecity/spread-sheets";
import { ENV } from "./config";
import { msalInstance } from "./core/services/msalInstance";
import { SESSION_CONSTANT } from "./shared/utils/SessionConstants";

import "./index.css";
import "./reset.css";
import "./extensions/extension";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
if (ENV.REACT_APP_LICENSE_KEY) {
  GC.Spread.Sheets.LicenseKey = ENV.REACT_APP_LICENSE_KEY;
}

msalInstance.initialize().then(async () => {
  // Handle the redirect BEFORE React renders, so App.tsx sees a clean state.
  // If this is a redirect response (auth code in URL hash), result is non-null.
  const redirectResult = await msalInstance.handleRedirectPromise();
  if (redirectResult?.account) {
    // Set the active account immediately so acquireTokenSilent works
    msalInstance.setActiveAccount(redirectResult.account);
    try {
      const tokenResponse = await msalInstance.acquireTokenSilent({
        scopes: [`api://${window._env_?.AZURE_AD_CLIENT_ID}/access_as_user`],
        account: redirectResult.account,
      });
      localStorage.setItem(SESSION_CONSTANT.TOKEN_KEY, tokenResponse.accessToken);

      // Register SSO session before navigating — ensures refresh_token row
      // exists before any page components fire API calls simultaneously
      try {
        await fetch(`${ENV.API_URL}/api/auth/sso-session`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tokenResponse.accessToken}`,
            "Content-Type": "application/json",
          },
        });
        console.log("[MSAL] SSO session registered with BackEnd");
      } catch (err) {
        console.error("[MSAL] SSO session registration failed:", err);
        // Continue anyway — worst case the first API call may 401 and retry
      }

      window.location.replace("/clients");
      console.log("[MSAL] SSO login complete — token written to localStorage");
    } catch (err) {
      console.error("[MSAL] acquireTokenSilent after redirect failed:", err);
    }
  }
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
});
